import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {CustomScrollbarDirective} from "../../../../../../../shared/directives/custom-scrollbar/custom-scrollbar.directive";

@Component({
    selector: 'db-create-ai-assistant-template',
    templateUrl: './create-ai-assistant-template.component.html',
    styleUrls: ['./create-ai-assistant-template.component.scss'],
    standalone: false
})
export class CreateAiAssistantTemplateComponent implements OnChanges {

  @Input() template;
  @Input() theme;
  @Input() scrollToTop?: boolean = false;
  @Input() imagesLoading;
  @Input() selectedTemplate = '';
  @Input() newScreenShots: boolean = false;
  @ViewChild(CustomScrollbarDirective) dir: CustomScrollbarDirective;

  scrollTo(scrollTop: number): void {
    setTimeout(() => {
      const el = document.getElementById("db-create-ai-assistant-template-select__template_" + this.template.template_id);
      el.scroll({
        top: scrollTop,
        left: 0,
        behavior: 'smooth'
      });
    }, 50);
  }

  ngOnChanges() {
    if (this.scrollToTop ) {
      this.scrollTo(0);
    }
  }
}
